import React from "react";
import {DetailDialog, DetailDialogProps} from "../../../../components/DetailDialog";
import {DISP_MODE, EQUIPMENT_URLS, URL_PARAMS} from "../../../../constants/constants";

export interface FingertipDetailDialogProps extends Omit<DetailDialogProps, 'title' | 'src'> {
  fingertipId: string,
  // eslint-disable-next-line camelcase,react/require-default-props
  mountPattern?: string,
}

export function FingertipDetailDialog(props: FingertipDetailDialogProps) {
  const params = new URLSearchParams();
  params.append(EQUIPMENT_URLS.FINGERTIP_DETAIL.QUERY_MOUNT_PATTERN, props.mountPattern ?? '');
  params.append(URL_PARAMS.DISP_MODE, DISP_MODE.POPUP);
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <DetailDialog {...props} title='爪詳細' src={`${EQUIPMENT_URLS.FINGERTIP_DETAIL.URL}/${props.fingertipId}?${params.toString()}`}/>
  )
}
